// extracted by mini-css-extract-plugin
export default {"root":"TSIfjC","trigger":"b9v_zH","ellipsis":"ogG9T5","fillCurrentColor":"miQokp","nav":"Ppgrlx","link":"im52_V","itemSticky":"E_9YFK"};